import { render, staticRenderFns } from "./UserAssignment.vue?vue&type=template&id=6981eedc&scoped=true"
import script from "./UserAssignment.vue?vue&type=script&lang=js"
export * from "./UserAssignment.vue?vue&type=script&lang=js"
import style0 from "./UserAssignment.vue?vue&type=style&index=0&id=6981eedc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6981eedc",
  null
  
)

export default component.exports